// components/LazyLoader/LazyLoader.jsx
import React from 'react';
import './LazyLoader.scss';

const LazyLoader = () => {
  const loadingPhrases = [
    "Getting everything ready...",
    "Loading awesome features...",
    "Almost there...",
    "Preparing your experience...",
    "Setting up the magic..."
  ];

  return (
    <div className="lazy-loader">
      <div className="lazy-loader__content">
        <div className="lazy-loader__animation">
          {/* Animated Logo or Brand Icon */}
          <div className="lazy-loader__logo">
            <svg viewBox="0 0 24 24" className="lazy-loader__icon">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
            </svg>
          </div>
          
          {/* Progress Indicator */}
          <div className="lazy-loader__progress">
            <div className="lazy-loader__bar"></div>
          </div>

          {/* Loading Message */}
          <div className="lazy-loader__message">
            {loadingPhrases.map((phrase, index) => (
              <span key={index} className="lazy-loader__phrase">{phrase}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LazyLoader;